var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { status, } from "@spike/appointment-model";
import { convertToYMDWithoutTimeZone, getYesterdayAsYMD } from "@spike/date-utils";
import { showError, showSuccess, } from "@spike/notifications-action";
import axios from "axios";
import moment from "moment";
import { bookingAssignStaff } from "../../bookings/action/BookingsActions";
import { convertToBooking } from "../../bookings/action/BookingsConverter";
import { APPOINTMENTS_ASSIGN_STAFF_START_ACTION_TYPE, APPOINTMENTS_ASSIGN_STAFF_SUCCESS_ACTION_TYPE, APPOINTMENTS_CANCEL_SEVERAL_LOCAL_ACTION_TYPE, APPOINTMENTS_CHANGE_NOTES_START_ACTION_TYPE, APPOINTMENTS_CHANGE_NOTES_SUCCESS_ACTION_TYPE, APPOINTMENTS_CHANGE_SERVICE_START_ACTION_TYPE, APPOINTMENTS_CHANGE_SERVICE_SUCCESS_ACTION_TYPE, APPOINTMENTS_CHANGE_STATUS_START_ACTION_TYPE, APPOINTMENTS_CHANGE_STATUS_SUCCESS_ACTION_TYPE, APPOINTMENTS_COMPLETE_START_ACTION_TYPE, APPOINTMENTS_COMPLETE_SUCCESS_ACTION_TYPE, APPOINTMENTS_COUNT_CLIENT_START_ACTION_TYPE, APPOINTMENTS_COUNT_CLIENT_SUCCESS_ACTION_TYPE, APPOINTMENTS_COUNT_RECURRENT_START_ACTION_TYPE, APPOINTMENTS_COUNT_RECURRENT_SUCCESS_ACTION_TYPE, APPOINTMENTS_COUNT_START_ACTION_TYPE, APPOINTMENTS_COUNT_SUCCESS_ACTION_TYPE, APPOINTMENTS_DECLINE_START_ACTION_TYPE, APPOINTMENTS_DECLINE_SUCCESS_ACTION_TYPE, APPOINTMENTS_DELETE_START_ACTION_TYPE, APPOINTMENTS_DELETE_SUCCESS_ACTION_TYPE, APPOINTMENTS_NOT_FOUND_ACTION_TYPE, APPOINTMENTS_ERROR_ACTION_TYPE, APPOINTMENTS_FETCH_CLIENT_MERGEABLES_START_ACTION_TYPE, APPOINTMENTS_FETCH_CLIENT_MERGEABLES_SUCCESS_ACTION_TYPE, APPOINTMENTS_FETCH_CLIENT_PENDINGS_START_ACTION_TYPE, APPOINTMENTS_FETCH_CLIENT_PENDINGS_SUCCESS_ACTION_TYPE, APPOINTMENTS_FETCH_CLIENT_START_ACTION_TYPE, APPOINTMENTS_FETCH_CLIENT_SUCCESS_ACTION_TYPE, APPOINTMENTS_FETCH_CLIENT_WITH_STAFF_ISSUES_START_ACTION_TYPE, APPOINTMENTS_FETCH_CLIENT_WITH_STAFF_ISSUES_SUCCESS_ACTION_TYPE, APPOINTMENTS_FETCH_INVOICE_APPOINTMENTS_START_ACTION_TYPE, APPOINTMENTS_FETCH_INVOICE_APPOINTMENTS_SUCCESS_ACTION_TYPE, APPOINTMENTS_FETCH_MERGEABLES_START_ACTION_TYPE, APPOINTMENTS_FETCH_MERGEABLES_SUCCESS_ACTION_TYPE, APPOINTMENTS_FETCH_PENDINGS_START_ACTION_TYPE, APPOINTMENTS_FETCH_PENDINGS_SUCCESS_ACTION_TYPE, APPOINTMENTS_FETCH_START_ACTION_TYPE, APPOINTMENTS_FETCH_SUCCESS_ACTION_TYPE, APPOINTMENTS_FETCH_WITH_STAFF_ISSUES_START_ACTION_TYPE, APPOINTMENTS_FETCH_WITH_STAFF_ISSUES_SUCCESS_ACTION_TYPE, APPOINTMENTS_GET_HISTORY_START_ACTION_TYPE, APPOINTMENTS_GET_HISTORY_SUCCESS_ACTION_TYPE, APPOINTMENTS_GET_LIMITS_START_ACTION_TYPE, APPOINTMENTS_GET_LIMITS_SUCCESS_ACTION_TYPE, APPOINTMENTS_GET_START_ACTION_TYPE, APPOINTMENTS_GET_SUCCESS_ACTION_TYPE, APPOINTMENTS_REMOVE_LOCAL_ACTION_TYPE, APPOINTMENTS_REMOVE_SEVERAL_LOCAL_ACTION_TYPE, APPOINTMENTS_RESET_ACTION_TYPE, APPOINTMENTS_UPDATE_LOCAL_ACTION_TYPE, } from "./AppointmentsActionsTypes";
import { convertToAppointment, convertToLog, convertToRecurrent, } from "./AppointmentsConverter";
export var appointmentsUrl = "/appointments";
var completeAppointmentUrl = "/appointment/complete";
var declineAppointmentUrl = "/appointment/decline";
var bookingLogUrl = "/booking/logs";
var bookingsUrl = "/bookings";
var limitsUrl = "/booking/limits";
var appointmentsWithStaffIssuesUrl = "/appointments_to_check";
var clientAppointmentsWithStaffIssuesUrl = "/appointments_to_check_by_customer";
var clientAppointmentsUrl = "/appointments_by_customer";
var recurring = "/recurring_appointment";
var countUrl = "bookings_pending_issues_count";
var clientCountUrl = "bookings_pending_issues_count_by_customer";
var HTTP_STATUS_404_NOT_FOUND = 404;
var isLastFetch = function (requestUuid, appointmentsState) {
    return appointmentsState.lastFetchRequestUuid === requestUuid;
};
var isLastClientFetch = function (requestUuid, appointmentsState) {
    return (appointmentsState.clientAppointments.lastFetchRequestUuid === requestUuid);
};
export var countThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(countStart());
                    url = "".concat(countUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(countSuccess({
                        bookings: {
                            pendings: response.data.booking_pending_booked_count,
                            withIssues: response.data.booking_issues_count,
                        },
                        appointments: {
                            pendings: response.data.appointment_pending_count,
                            withIssues: response.data.appointment_issues_count,
                        },
                    }));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_1 = _a.sent();
                    if (!axios.isCancel(apiError_1)) {
                        dispatch(error());
                        dispatch(showError("Error counting appointments and bookings."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var clientCountThunk = function (apiClientWrapper, clientId, petIds) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(countClientStart());
                    url = "".concat(clientCountUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&customer_id=").concat(clientId, "&pet_id=").concat(petIds);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(countClientSuccess({
                        bookings: {
                            pendings: response.data.booking_pending_count,
                            withIssues: response.data.booking_issues_count,
                        },
                        appointments: {
                            pendings: response.data.appointment_pending_count,
                            withIssues: response.data.appointment_issues_count,
                        },
                    }, clientId, petIds));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_2 = _a.sent();
                    if (!axios.isCancel(apiError_2)) {
                        dispatch(error());
                        dispatch(showError("Error counting appointments and bookings."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var refetchAppointmentsThunk = function (apiClientWrapper) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (getState().appointments.filter.withStaffIssues) {
                dispatch(fetchAppointmentsWithStaffIssuesThunk(apiClientWrapper));
            }
            else {
                dispatch(fetchAppointmentsThunk(apiClientWrapper, getState().appointments.filter.statusIds, getState().appointments.filter.from, getState().appointments.filter.to));
            }
            return [2 /*return*/];
        });
    }); };
};
export var refetchClientAppointmentsThunk = function (apiClientWrapper) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var clientId, statusIds, from, to, petIds;
        return __generator(this, function (_a) {
            clientId = getState().appointments.clientAppointments.filter.clientId;
            statusIds = getState().appointments.clientAppointments.filter.statusIds;
            from = getState().appointments.clientAppointments.filter.from;
            to = getState().appointments.clientAppointments.filter.to;
            petIds = getState().appointments.clientAppointments.filter.petIds;
            if (clientId) {
                if (getState().appointments.clientAppointments.filter.withStaffIssues) {
                    dispatch(fetchClientAppointmentsWithStaffIssuesThunk(apiClientWrapper, clientId, petIds));
                }
                else {
                    dispatch(fetchClientAppointmentsThunk(apiClientWrapper, statusIds, from, to, clientId, petIds));
                }
            }
            return [2 /*return*/];
        });
    }); };
};
export var fetchAppointmentsThunk = function (apiClientWrapper, statusIds, from, to, staffIds) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, url, response, apiError_3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(fetchStart(statusIds, from, to, staffIds || [], requestUuid));
                    url = "".concat(appointmentsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&start_date=").concat(from === null ? "" : from, "&end_date=").concat(to === null ? "" : to, "&status_ids=").concat(statusIds, "&staff_ids=").concat(staffIds || "");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastFetch(requestUuid, getState().appointments) &&
                        dispatch(fetchSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_3 = _a.sent();
                    if (!axios.isCancel(apiError_3)) {
                        dispatch(error());
                        dispatch(showError("Error fetching appointments."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchClientAppointmentsThunk = function (apiClientWrapper, statusIds, from, to, clientId, petIds) {
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, url, response, apiError_4;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(fetchClientStart(clientId, petIds, statusIds, from, to, requestUuid));
                    url = "".concat(clientAppointmentsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&customer_id=").concat(clientId, "&start_date=").concat(from === null ? "" : from, "&end_date=").concat(to === null ? "" : to, "&status_ids=").concat(statusIds, "&pet_id=").concat(petIds);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastClientFetch(requestUuid, getState().appointments) &&
                        dispatch(fetchClientSuccess(clientId, petIds, response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_4 = _a.sent();
                    if (!axios.isCancel(apiError_4)) {
                        dispatch(error());
                        dispatch(showError("Error fetching client appointments."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchInvoiceAppointmentsThunk = function (apiClientWrapper, appointmentIds) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_5;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchInvoiceAppointmentsStart());
                    url = "".concat(appointmentsUrl, "/").concat(appointmentIds, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(fetchInvoiceAppointmentsSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_5 = _a.sent();
                    if (!axios.isCancel(apiError_5)) {
                        dispatch(error());
                        dispatch(showError("Error fetching invoice appointments."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchPendingAppointmentsThunk = function (apiClientWrapper) {
    var statusIds = [
        status.CONFIRMED,
        status.CHECKED_IN,
        status.IN_PROGRESS,
        status.READY_FOR_CHECK_OUT,
        status.PAYMENT,
    ];
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, yesterdayAsString, fromDate, start_date, url, response, apiError_6;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    yesterdayAsString = getYesterdayAsYMD(apiClientWrapper.timeZone);
                    fromDate = (_a = getState().appointments.limits) === null || _a === void 0 ? void 0 : _a.from;
                    start_date = fromDate ? convertToYMDWithoutTimeZone(fromDate) : '2010-01-01';
                    dispatch(fetchPendingsStart(yesterdayAsString, statusIds, requestUuid));
                    url = "".concat(appointmentsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&start_date=").concat(start_date, "&end_date=").concat(yesterdayAsString, "&status_ids=").concat(statusIds);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _b.sent();
                    isLastFetch(requestUuid, getState().appointments) &&
                        dispatch(fetchPendingsSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_6 = _b.sent();
                    if (!axios.isCancel(apiError_6)) {
                        dispatch(error());
                        dispatch(showError("Error fetching pending appointments."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchClientPendingAppointmentsThunk = function (apiClientWrapper, clientId, petIds) {
    var statusIds = [
        status.CONFIRMED,
        status.CHECKED_IN,
        status.IN_PROGRESS,
        status.READY_FOR_CHECK_OUT,
    ];
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, yesterdayAsString, url, response, apiError_7;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    yesterdayAsString = getYesterdayAsYMD(apiClientWrapper.timeZone);
                    dispatch(fetchClientPendingsStart(clientId, petIds, yesterdayAsString, statusIds, requestUuid));
                    url = "".concat(clientAppointmentsUrl, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&customer_id=").concat(clientId, "&end_date=").concat(yesterdayAsString, "&start_date=2020-01-01&status_ids=").concat(statusIds, "$&pet_id=").concat(petIds);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastClientFetch(requestUuid, getState().appointments) &&
                        dispatch(fetchClientPendingsSuccess(clientId, petIds, response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_7 = _a.sent();
                    if (!axios.isCancel(apiError_7)) {
                        dispatch(error());
                        dispatch(showError("Error fetching client pending appointments."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchAppointmentsWithStaffIssuesThunk = function (apiClientWrapper) {
    var statusIds = [
        status.CONFIRMED,
        status.CHECKED_IN,
        status.IN_PROGRESS,
        status.READY_FOR_CHECK_OUT,
    ];
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, url, response, apiError_8;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(fetchWithStaffIssuesStart(statusIds, requestUuid));
                    url = "".concat(appointmentsWithStaffIssuesUrl, "?&marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastFetch(requestUuid, getState().appointments) &&
                        dispatch(fetchWithStaffIssuesSuccess(response.data.filter(function (dto) { return statusIds.includes(dto.status); }), apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_8 = _a.sent();
                    if (!axios.isCancel(apiError_8)) {
                        dispatch(error());
                        dispatch(showError("Error fetching appointments with staff issues."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchClientAppointmentsWithStaffIssuesThunk = function (apiClientWrapper, clientId, petIds) {
    var statusIds = [
        status.CONFIRMED,
        status.CHECKED_IN,
        status.IN_PROGRESS,
        status.READY_FOR_CHECK_OUT,
    ];
    return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
        var requestUuid, url, response, apiError_9;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestUuid = apiClientWrapper.uuid();
                    dispatch(fetchClientWithStaffIssuesStart(clientId, petIds, statusIds, requestUuid));
                    url = "".concat(clientAppointmentsWithStaffIssuesUrl, "?&marketplace_id=").concat(apiClientWrapper.marketplaceId, "&customer_id=").concat(clientId, "&pet_id=").concat(petIds);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    isLastClientFetch(requestUuid, getState().appointments) &&
                        dispatch(fetchClientWithStaffIssuesSuccess(clientId, petIds, response.data.filter(function (dto) { return statusIds.includes(dto.status); }), apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_9 = _a.sent();
                    if (!axios.isCancel(apiError_9)) {
                        dispatch(error());
                        dispatch(showError("Error fetching client appointments with staff issues."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchMergeableAppointmentsThunk = function (apiClientWrapper, appointment) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, booking, apiError_10;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchMergeablesStart());
                    url = "".concat(bookingsUrl, "/").concat(appointment.bookingId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    booking = convertToBooking(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone);
                    dispatch(fetchMergeablesSuccess(booking.appointments));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_10 = _a.sent();
                    if (!axios.isCancel(apiError_10)) {
                        dispatch(error());
                        dispatch(showError("Error fetching mergeable appointments."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var fetchClientMergeableAppointmentsThunk = function (apiClientWrapper, appointment, clientId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, booking, apiError_11;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(fetchClientMergeablesStart());
                    url = "".concat(bookingsUrl, "/").concat(appointment.bookingId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&customer_id=").concat(clientId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    booking = convertToBooking(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone);
                    dispatch(fetchClientMergeablesSuccess(clientId, booking.appointments));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_11 = _a.sent();
                    if (!axios.isCancel(apiError_11)) {
                        dispatch(error());
                        dispatch(showError("Error fetching client mergeable appointments."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var changeStatusAppointmentThunk = function (apiClientWrapper, appointmentId, statusId, sendNotification) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_12;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(changeStatusStart());
                    url = "".concat(appointmentsUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    body = {
                        appointment: {
                            status: statusId,
                        },
                        send_notification: sendNotification,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(changeStatusSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_12 = _a.sent();
                    if (!axios.isCancel(apiError_12)) {
                        dispatch(error());
                        dispatch(showError("Error changing appointment status."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var cancelAppointmentThunk = function (apiClientWrapper, appointmentId, sendNotification, cancelationReasonId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_13;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(changeStatusStart());
                    url = "".concat(appointmentsUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    body = {
                        appointment: {
                            status: status.CANCELLED,
                            cancelation_reason_id: cancelationReasonId || null,
                        },
                        send_notification: sendNotification,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(changeStatusSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    dispatch(showSuccess("Appointment canceled."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_13 = _a.sent();
                    if (!axios.isCancel(apiError_13)) {
                        dispatch(error());
                        dispatch(showError("Error canceling appointment."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var cancelRecurrentAppointmentsThunk = function (apiClientWrapper, appointmentId, statusId, sendNotification, cancelationReasonId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_14;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(changeStatusStart());
                    url = "".concat(appointmentsUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&cancel_recurrent=true");
                    body = {
                        appointment: {
                            status: statusId,
                            cancelation_reason_id: cancelationReasonId || null,
                        },
                        send_notification: sendNotification,
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(changeStatusSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    dispatch(showSuccess("Recurrent appointments canceled."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_14 = _a.sent();
                    if (!axios.isCancel(apiError_14)) {
                        dispatch(error());
                        dispatch(showError("Error canceling recurrent appointments."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var changeAppointmentServiceThunk = function (apiClientWrapper, appointmentId, serviceId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_15;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(changeServiceStart());
                    url = "".concat(appointmentsUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    body = {
                        appointment: {
                            service_id: serviceId,
                        },
                    };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(changeServiceSuccess(convertToAppointment(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    dispatch(showSuccess("Appointment service updated."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_15 = _a.sent();
                    if (!axios.isCancel(apiError_15)) {
                        dispatch(error());
                        dispatch(showError("Error updating appointment service."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var completeAppointmentThunk = function (apiClientWrapper, appointmentId, sendSms) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, requestBody, response, apiError_16;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(completeStart());
                    url = "".concat(completeAppointmentUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    requestBody = { send_sms: sendSms };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, requestBody, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(completeSuccess(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_16 = _a.sent();
                    if (!axios.isCancel(apiError_16)) {
                        dispatch(error());
                        dispatch(showError("Error completing appointment."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var declineAppointmentThunk = function (apiClientWrapper, appointmentId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_17;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(declineStart());
                    url = "".concat(declineAppointmentUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.post(url, undefined, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(declineSuccess(convertToAppointment(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_17 = _a.sent();
                    if (!axios.isCancel(apiError_17)) {
                        dispatch(error());
                        dispatch(showError("Error declining appointment."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteAppointmentThunk = function (apiClientWrapper, appointmentId, hideNotification) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, apiError_18;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteStart(appointmentId));
                    url = "".concat(appointmentsUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.delete(url, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(deleteSuccess(appointmentId));
                    !hideNotification && dispatch(showSuccess("Appointment deleted."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_18 = _a.sent();
                    if (!axios.isCancel(apiError_18)) {
                        if (apiError_18.response &&
                            apiError_18.response.status === HTTP_STATUS_404_NOT_FOUND) {
                            dispatch(notFound());
                        }
                        else {
                            dispatch(error());
                            !hideNotification && dispatch(showError("Error deleting appointment."));
                            dispatch(refetchAppointmentsThunk(apiClientWrapper));
                        }
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var deleteRecurrentAppointmentsThunk = function (apiClientWrapper, appointmentId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, apiError_19;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(deleteStart(appointmentId));
                    url = "".concat(appointmentsUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId, "&destroy_recurrent=true");
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.delete(url, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(deleteSuccess(appointmentId));
                    dispatch(showSuccess("Recurrent appointments deleted."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_19 = _a.sent();
                    if (!axios.isCancel(apiError_19)) {
                        dispatch(error());
                        dispatch(showError("Error deleting recurrent appointments."));
                        dispatch(refetchAppointmentsThunk(apiClientWrapper));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var countRecurrentAppointmentsThunk = function (apiClientWrapper, appointmentId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_20;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(countRecurrentStart(appointmentId));
                    url = "".concat(recurring, "/count/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(countRecurrentSuccess(convertToRecurrent(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_20 = _a.sent();
                    if (!axios.isCancel(apiError_20)) {
                        dispatch(error());
                        dispatch(showError("Error counting recurring appointments."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var changeAppointmentNotesThunk = function (apiClientWrapper, appointmentId, notes) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, body, response, apiError_21;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(changeNotesStart());
                    url = "".concat(appointmentsUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    body = { notes: notes };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(changeNotesSuccess(convertToAppointment(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_21 = _a.sent();
                    if (!axios.isCancel(apiError_21)) {
                        dispatch(error());
                        dispatch(showError("Error updating appointment's notes."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var assignAppointmentStaffThunk = function (apiClientWrapper, appointmentId, staff) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var appointmentStaff, url, body, apiError_22;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    appointmentStaff = staff
                        ? __assign(__assign({}, staff), { incorrectAssigned: false, overassigned: false }) : undefined;
                    dispatch(assignStaffStart(appointmentId, appointmentStaff));
                    dispatch(bookingAssignStaff(appointmentId, appointmentStaff));
                    url = "".concat(appointmentsUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    body = { appointment: { staff_id: (staff === null || staff === void 0 ? void 0 : staff.id) || null } };
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.patch(url, body, apiClientWrapper.requestConfig)];
                case 2:
                    _a.sent();
                    dispatch(assignStaffSuccess());
                    dispatch(showSuccess("Appointment staff assigned."));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_22 = _a.sent();
                    if (!axios.isCancel(apiError_22)) {
                        dispatch(error());
                        dispatch(showError("Error assigning appointment staff."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getAppointmentHistoryThunk = function (apiClientWrapper, bookingId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_23;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getHistoryStart());
                    url = "".concat(bookingLogUrl, "/").concat(bookingId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getHistorySuccess(response.data.map(function (logDto) { return convertToLog(logDto); })));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_23 = _a.sent();
                    if (!axios.isCancel(apiError_23)) {
                        dispatch(error());
                        dispatch(showError("Error getting appointment history."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getLimitsThunk = function (apiClientWrapper) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_24;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getLimitsStart());
                    url = "".concat(limitsUrl, "?&marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getLimitsSuccess({
                        from: moment(response.data.first_appointment_date).tz(apiClientWrapper.timeZone),
                        to: moment(response.data.last_appointment_date).tz(apiClientWrapper.timeZone),
                    }));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_24 = _a.sent();
                    if (!axios.isCancel(apiError_24)) {
                        dispatch(error());
                        dispatch(showError("Error getting appointments limits."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var getAppointmentThunk = function (apiClientWrapper, appointmentId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var url, response, apiError_25;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    dispatch(getStart());
                    url = "".concat(appointmentsUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
                case 2:
                    response = _a.sent();
                    dispatch(getSuccess(convertToAppointment(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone)));
                    return [3 /*break*/, 4];
                case 3:
                    apiError_25 = _a.sent();
                    if (!axios.isCancel(apiError_25)) {
                        dispatch(error());
                        dispatch(showError("Error getting appointment."));
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
};
export var updateLocalAppointmentThunk = function (appointmentDto, masterData, timeZone) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(updateLocal(convertToAppointment(appointmentDto, masterData, timeZone)));
            return [2 /*return*/];
        });
    }); };
};
export var removeLocalAppointmentThunk = function (appointmentId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(removeLocal(appointmentId));
            return [2 /*return*/];
        });
    }); };
};
export var removeSeveralLocalAppointmentThunk = function (appointmentIds) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(removeSeveralLocal(appointmentIds));
            return [2 /*return*/];
        });
    }); };
};
export var cancelSeveralLocalAppointmentThunk = function (appointmentIds, masterData) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            dispatch(cancelSeveralLocal(appointmentIds, masterData.status.find(function (option) { return option.id === status.CANCELLED; })));
            return [2 /*return*/];
        });
    }); };
};
export var updateLocalAppointmentByIdThunk = function (apiClientWrapper, appointmentId) {
    return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
        var appointment, apiError_26;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, getAppointment(apiClientWrapper, appointmentId)];
                case 1:
                    appointment = _a.sent();
                    //console.info({action: "Update appointment", appointment});
                    dispatch(updateLocal(appointment));
                    return [3 /*break*/, 3];
                case 2:
                    apiError_26 = _a.sent();
                    //console.info({action: "Error appointment", status: apiError.response?.status, appointmentId});
                    apiError_26.response.status === 404 && console.info("remove appointment");
                    apiError_26.response.status === 404 && dispatch(removeLocal(appointmentId));
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); };
};
export var resetAppointments = function () {
    return {
        type: APPOINTMENTS_RESET_ACTION_TYPE,
    };
};
var fetchInvoiceAppointmentsStart = function () {
    return {
        type: APPOINTMENTS_FETCH_INVOICE_APPOINTMENTS_START_ACTION_TYPE,
    };
};
var fetchInvoiceAppointmentsSuccess = function (appointmentsDto, masterData, timeZone) {
    return {
        type: APPOINTMENTS_FETCH_INVOICE_APPOINTMENTS_SUCCESS_ACTION_TYPE,
        payload: {
            appointments: Array.isArray(appointmentsDto)
                ? appointmentsDto.map(function (dto) {
                    return convertToAppointment(dto, masterData, timeZone);
                })
                : [convertToAppointment(appointmentsDto, masterData, timeZone)],
        },
    };
};
var fetchStart = function (statusIds, from, to, staffIds, requestUuid) {
    return {
        type: APPOINTMENTS_FETCH_START_ACTION_TYPE,
        payload: {
            statusIds: statusIds,
            from: from,
            to: to,
            staffIds: staffIds,
            requestUuid: requestUuid,
        },
    };
};
var fetchSuccess = function (appointmentsDto, masterData, timeZone) {
    return {
        type: APPOINTMENTS_FETCH_SUCCESS_ACTION_TYPE,
        payload: {
            appointments: appointmentsDto.map(function (dto) {
                return convertToAppointment(dto, masterData, timeZone);
            }),
        },
    };
};
var fetchClientStart = function (clientId, petIds, statusIds, from, to, requestUuid) {
    return {
        type: APPOINTMENTS_FETCH_CLIENT_START_ACTION_TYPE,
        payload: {
            clientId: clientId,
            petIds: petIds,
            statusIds: statusIds,
            from: from,
            to: to,
            requestUuid: requestUuid,
        },
    };
};
var fetchClientSuccess = function (clientId, petIds, appointmentsDto, masterData, timeZone) {
    return {
        type: APPOINTMENTS_FETCH_CLIENT_SUCCESS_ACTION_TYPE,
        payload: {
            appointments: appointmentsDto.map(function (dto) {
                return convertToAppointment(dto, masterData, timeZone);
            }),
            clientId: clientId,
            petIds: petIds,
        },
    };
};
var fetchPendingsStart = function (to, statusIds, requestUuid) {
    return {
        type: APPOINTMENTS_FETCH_PENDINGS_START_ACTION_TYPE,
        payload: {
            requestUuid: requestUuid,
            to: to,
            statusIds: statusIds,
        },
    };
};
var fetchPendingsSuccess = function (appointmentsDto, masterData, timeZone) {
    return {
        type: APPOINTMENTS_FETCH_PENDINGS_SUCCESS_ACTION_TYPE,
        payload: {
            appointments: appointmentsDto.map(function (dto) {
                return convertToAppointment(dto, masterData, timeZone);
            }),
        },
    };
};
var fetchClientPendingsStart = function (clientId, petIds, to, statusIds, requestUuid) {
    return {
        type: APPOINTMENTS_FETCH_CLIENT_PENDINGS_START_ACTION_TYPE,
        payload: {
            clientId: clientId,
            petIds: petIds,
            to: to,
            statusIds: statusIds,
            requestUuid: requestUuid,
        },
    };
};
var fetchClientPendingsSuccess = function (clientId, petIds, appointmentsDto, masterData, timeZone) {
    return {
        type: APPOINTMENTS_FETCH_CLIENT_PENDINGS_SUCCESS_ACTION_TYPE,
        payload: {
            appointments: appointmentsDto.map(function (dto) {
                return convertToAppointment(dto, masterData, timeZone);
            }),
            clientId: clientId,
            petIds: petIds,
        },
    };
};
var fetchWithStaffIssuesStart = function (statusIds, requestUuid) {
    return {
        type: APPOINTMENTS_FETCH_WITH_STAFF_ISSUES_START_ACTION_TYPE,
        payload: {
            statusIds: statusIds,
            requestUuid: requestUuid,
        },
    };
};
var fetchWithStaffIssuesSuccess = function (appointmentsDto, masterData, timeZone) {
    return {
        type: APPOINTMENTS_FETCH_WITH_STAFF_ISSUES_SUCCESS_ACTION_TYPE,
        payload: {
            appointments: appointmentsDto.map(function (dto) {
                return convertToAppointment(dto, masterData, timeZone);
            }),
        },
    };
};
var fetchClientWithStaffIssuesStart = function (clientId, petIds, statusIds, requestUuid) {
    return {
        type: APPOINTMENTS_FETCH_CLIENT_WITH_STAFF_ISSUES_START_ACTION_TYPE,
        payload: {
            clientId: clientId,
            petIds: petIds,
            statusIds: statusIds,
            requestUuid: requestUuid,
        },
    };
};
var fetchClientWithStaffIssuesSuccess = function (clientId, petIds, appointmentsDto, masterData, timeZone) {
    return {
        type: APPOINTMENTS_FETCH_CLIENT_WITH_STAFF_ISSUES_SUCCESS_ACTION_TYPE,
        payload: {
            appointments: appointmentsDto.map(function (dto) {
                return convertToAppointment(dto, masterData, timeZone);
            }),
            clientId: clientId,
            petIds: petIds,
        },
    };
};
var fetchMergeablesStart = function () {
    return {
        type: APPOINTMENTS_FETCH_MERGEABLES_START_ACTION_TYPE,
    };
};
var fetchMergeablesSuccess = function (appointments) {
    return {
        type: APPOINTMENTS_FETCH_MERGEABLES_SUCCESS_ACTION_TYPE,
        payload: {
            mergeableAppointments: appointments,
        },
    };
};
var fetchClientMergeablesStart = function () {
    return {
        type: APPOINTMENTS_FETCH_CLIENT_MERGEABLES_START_ACTION_TYPE,
    };
};
var fetchClientMergeablesSuccess = function (clientId, appointments) {
    return {
        type: APPOINTMENTS_FETCH_CLIENT_MERGEABLES_SUCCESS_ACTION_TYPE,
        payload: {
            mergeableAppointments: appointments,
            clientId: clientId,
        },
    };
};
var changeStatusStart = function () {
    return {
        type: APPOINTMENTS_CHANGE_STATUS_START_ACTION_TYPE,
    };
};
var changeStatusSuccess = function (appointmentDto, masterData, timeZone) {
    return {
        type: APPOINTMENTS_CHANGE_STATUS_SUCCESS_ACTION_TYPE,
        payload: {
            appointment: convertToAppointment(appointmentDto, masterData, timeZone),
        },
    };
};
var completeStart = function () {
    return {
        type: APPOINTMENTS_COMPLETE_START_ACTION_TYPE,
    };
};
var completeSuccess = function (appointmentDto, masterData, timeZone) {
    return {
        type: APPOINTMENTS_COMPLETE_SUCCESS_ACTION_TYPE,
        payload: {
            appointment: convertToAppointment(appointmentDto, masterData, timeZone),
        },
    };
};
var declineStart = function () {
    return {
        type: APPOINTMENTS_DECLINE_START_ACTION_TYPE,
    };
};
var declineSuccess = function (appointment) {
    return {
        type: APPOINTMENTS_DECLINE_SUCCESS_ACTION_TYPE,
        payload: {
            appointment: appointment,
        },
    };
};
var changeNotesStart = function () {
    return {
        type: APPOINTMENTS_CHANGE_NOTES_START_ACTION_TYPE,
    };
};
var changeNotesSuccess = function (appointment) {
    return {
        type: APPOINTMENTS_CHANGE_NOTES_SUCCESS_ACTION_TYPE,
        payload: {
            appointment: appointment,
        },
    };
};
var changeServiceStart = function () {
    return {
        type: APPOINTMENTS_CHANGE_SERVICE_START_ACTION_TYPE,
    };
};
var changeServiceSuccess = function (appointment) {
    return {
        type: APPOINTMENTS_CHANGE_SERVICE_SUCCESS_ACTION_TYPE,
        payload: {
            appointment: appointment,
        },
    };
};
var assignStaffStart = function (appointmentId, staff) {
    return {
        type: APPOINTMENTS_ASSIGN_STAFF_START_ACTION_TYPE,
        payload: {
            appointmentId: appointmentId,
            staff: staff,
        },
    };
};
var assignStaffSuccess = function () {
    return {
        type: APPOINTMENTS_ASSIGN_STAFF_SUCCESS_ACTION_TYPE,
    };
};
var deleteStart = function (appointmentId) {
    return {
        type: APPOINTMENTS_DELETE_START_ACTION_TYPE,
        payload: {
            appointmentId: appointmentId,
        },
    };
};
var deleteSuccess = function (appointmentId) {
    return {
        type: APPOINTMENTS_DELETE_SUCCESS_ACTION_TYPE,
        payload: {
            appointmentId: appointmentId,
        },
    };
};
var countRecurrentStart = function (appointmentId) {
    return {
        type: APPOINTMENTS_COUNT_RECURRENT_START_ACTION_TYPE,
        payload: {
            appointmentId: appointmentId,
        },
    };
};
var countRecurrentSuccess = function (recurrent) {
    return {
        type: APPOINTMENTS_COUNT_RECURRENT_SUCCESS_ACTION_TYPE,
        payload: {
            recurrent: recurrent,
        },
    };
};
var getLimitsStart = function () {
    return {
        type: APPOINTMENTS_GET_LIMITS_START_ACTION_TYPE,
    };
};
var getLimitsSuccess = function (limits) {
    return {
        type: APPOINTMENTS_GET_LIMITS_SUCCESS_ACTION_TYPE,
        payload: {
            limits: limits,
        },
    };
};
var getHistoryStart = function () {
    return {
        type: APPOINTMENTS_GET_HISTORY_START_ACTION_TYPE,
    };
};
var getHistorySuccess = function (logs) {
    return {
        type: APPOINTMENTS_GET_HISTORY_SUCCESS_ACTION_TYPE,
        payload: {
            logs: logs,
        },
    };
};
var countStart = function () {
    return {
        type: APPOINTMENTS_COUNT_START_ACTION_TYPE,
    };
};
var countSuccess = function (counter) {
    return {
        type: APPOINTMENTS_COUNT_SUCCESS_ACTION_TYPE,
        payload: __assign({}, counter),
    };
};
var countClientStart = function () {
    return {
        type: APPOINTMENTS_COUNT_CLIENT_START_ACTION_TYPE,
    };
};
var countClientSuccess = function (counter, clientId, petIds) {
    return {
        type: APPOINTMENTS_COUNT_CLIENT_SUCCESS_ACTION_TYPE,
        payload: __assign(__assign({}, counter), { clientId: clientId, petIds: petIds }),
    };
};
var updateLocal = function (appointment) {
    return {
        type: APPOINTMENTS_UPDATE_LOCAL_ACTION_TYPE,
        payload: { appointment: appointment },
    };
};
var removeLocal = function (appointmentId) {
    return {
        type: APPOINTMENTS_REMOVE_LOCAL_ACTION_TYPE,
        payload: { appointmentId: appointmentId },
    };
};
var removeSeveralLocal = function (appointmentIds) {
    return {
        type: APPOINTMENTS_REMOVE_SEVERAL_LOCAL_ACTION_TYPE,
        payload: { appointmentIds: appointmentIds },
    };
};
var cancelSeveralLocal = function (appointmentIds, canceledStatus) {
    return {
        type: APPOINTMENTS_CANCEL_SEVERAL_LOCAL_ACTION_TYPE,
        payload: { appointmentIds: appointmentIds, canceledStatus: canceledStatus },
    };
};
var notFound = function () {
    return {
        type: APPOINTMENTS_NOT_FOUND_ACTION_TYPE,
    };
};
var error = function () {
    return {
        type: APPOINTMENTS_ERROR_ACTION_TYPE,
    };
};
var getStart = function () {
    return {
        type: APPOINTMENTS_GET_START_ACTION_TYPE,
    };
};
var getSuccess = function (appointment) {
    return {
        type: APPOINTMENTS_GET_SUCCESS_ACTION_TYPE,
        payload: {
            appointment: appointment,
        },
    };
};
export var getAppointment = function (apiClientWrapper, appointmentId) { return __awaiter(void 0, void 0, void 0, function () {
    var url, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                url = "".concat(appointmentsUrl, "/").concat(appointmentId, "?marketplace_id=").concat(apiClientWrapper.marketplaceId);
                return [4 /*yield*/, apiClientWrapper.apiClient.get(url, apiClientWrapper.requestConfig)];
            case 1:
                response = _a.sent();
                return [2 /*return*/, convertToAppointment(response.data, apiClientWrapper.masterData, apiClientWrapper.timeZone)];
        }
    });
}); };
